/* storybook-check-ignore */
import { Flex, Image, ImageProps } from '@opendoor/bricks/core';

function PersonChip({
  src,
  left,
  size = 42,
}: {
  src: ImageProps['src'];
  size?: number;
  left?: number;
}) {
  return (
    <Image
      overflow="hidden"
      position="absolute"
      alt="Support team person"
      left={left}
      src={src}
      height={size}
      width={size}
      borderRadius="rounded"
      border="1.4px solid #9D9D9D"
    />
  );
}

export default function SupportTeamChips({ size = 42 }: { size?: number }) {
  const leftPos = size / 7;
  return (
    <Flex flexDirection="row" position="relative" height={size} width={leftPos * 18 + size}>
      <PersonChip
        src="https://imgdrop.imgix.net/8125f39bd02244b3aa290b851d9fca77.png"
        size={size}
        left={0}
      />
      <PersonChip
        src="https://imgdrop.imgix.net/d15cb66af8ee4d23be6638b88e5b4325.png"
        size={size}
        left={leftPos * 6}
      />
      <PersonChip
        src="https://imgdrop.imgix.net/a847415114684752bffb677f1b2dbc38.png"
        size={size}
        left={leftPos * 12}
      />
      <PersonChip
        src="https://imgdrop.imgix.net/9df7514bd76e472cbe9c7c02cd5f5f6f.png"
        size={size}
        left={leftPos * 18}
      />
    </Flex>
  );
}
